import React, { useState } from 'react';
interface ContactPopupProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (name: string, email: string) => void;
}
export function ContactPopup({
  isOpen,
  onClose,
  onSubmit
}: ContactPopupProps) {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [nameError, setNameError] = useState('');
  const [emailError, setEmailError] = useState('');
  if (!isOpen) return null;
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // Validate inputs
    let isValid = true;
    if (!name.trim()) {
      setNameError('Nombre es requerido');
      isValid = false;
    } else {
      setNameError('');
    }
    if (!email.trim()) {
      setEmailError('Email es requerido');
      isValid = false;
    } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setEmailError('Email no es válido');
      isValid = false;
    } else {
      setEmailError('');
    }
    if (isValid) {
      onSubmit(name, email);
      setName('');
      setEmail('');
      onClose();
    }
  };
  return;
  return <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" data-id="element-94">
      <div className="relative bg-white p-8 w-full max-w-md corner-accent" data-id="element-95">
        <button onClick={onClose} className="absolute top-4 right-4 text-2xl font-bold" aria-label="Cerrar" data-id="element-96">
          ×
        </button>
        <div className="mb-6" data-id="element-97">
          <div className="text-xs uppercase tracking-wider mb-2 text-gray-600" data-id="element-98">
            CONTACTO
          </div>
          <h3 className="text-2xl font-bold mb-2" data-id="element-99">SOLICITAR PRUEBA</h3>
          <p className="text-sm text-gray-700 mb-4" data-id="element-100">
            Completa el formulario para que nuestro equipo se ponga en contacto
            contigo.
          </p>
        </div>
        <form onSubmit={handleSubmit} data-id="element-101">
          <div className="mb-4" data-id="element-102">
            <label className="block text-xs uppercase tracking-wider mb-1 text-gray-600" data-id="element-103">
              NOMBRE
            </label>
            <input type="text" value={name} onChange={e => setName(e.target.value)} className="w-full p-2 border border-gray-300 font-mono" placeholder="Tu nombre completo" data-id="element-104" />
            {nameError && <p className="text-xs text-red-600 mt-1" data-id="element-105">{nameError}</p>}
          </div>
          <div className="mb-6" data-id="element-106">
            <label className="block text-xs uppercase tracking-wider mb-1 text-gray-600" data-id="element-107">
              EMAIL
            </label>
            <input type="email" value={email} onChange={e => setEmail(e.target.value)} className="w-full p-2 border border-gray-300 font-mono" placeholder="tu@email.com" data-id="element-108" />
            {emailError && <p className="text-xs text-red-600 mt-1" data-id="element-109">{emailError}</p>}
          </div>
          <div className="flex justify-end" data-id="element-110">
            <button type="submit" className="relative px-8 py-3 bg-black text-white hover:bg-gray-800 transition-colors corner-accent" data-id="element-111">
              ENVIAR
            </button>
          </div>
        </form>
      </div>
    </div>;
}